/**
 * Inline `<head>` script that pays the browser's one-off `Intl` start-up cost
 * in a task of its own, before the app's JavaScript arrives.
 *
 * Whichever code first touches `Intl` pays for loading the browser's locale
 * data: ~20 ms on a 4x-throttled phone, ~60 ms at 12x, every later call costs
 * almost nothing. Today react-aria does it at module scope, inside the single
 * task that evaluates all of the app's modules, so the cost lands in the
 * page's longest task and counts in full towards Total Blocking Time. Here it
 * runs alone while the browser is waiting for the modules anyway.
 *
 * A constant with no interpolation, like the root's other inline scripts.
 */
export const WARM_INTL = `setTimeout(function () {
  try {
    new Intl.DateTimeFormat().format(0);
    new Intl.NumberFormat().format(0);
  } catch (e) {}
}, 0);`;
